export const randomString = (num = 5) =>
  Math.random()
    .toString(36)
    .substr(2, num);

export const properNoun = arg => arg.charAt(0).toUpperCase() + arg.slice(1).toLowerCase();

export const isEmpty = arg => Boolean(!arg || !arg.trim());
